import {useReducer, useEffect} from "react"
import{StWorkflowContext} from "../contexts/StWorkflowContext"
import stWorkflowReducer from "../reducers/stWorkflowRecucer"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null
    },
}

export default function StWorkflowProvider({children}) {
    const [stWorkflowContext, setStWorkflowAction] = useReducer(
        stWorkflowReducer,
        initialState,
    )

    useEffect(() => {
        if (stWorkflowContext) {
            localStorage.setItem("stWorkflowContext", JSON.stringify(stWorkflowContext))
        } else {
            localStorage.removeItem("stWorkflowContext")
        }
    }, [stWorkflowContext])

    return (
        <StWorkflowContext.Provider value={{stWorkflowContext, setStWorkflowAction}}>
            {children}
        </StWorkflowContext.Provider>
    )
}